import { EscrowStatusEnum } from 'src/graphql/schema';
import { OtherEscrowStatusEnum } from 'src/shared/constants';
import { BasicActivateProgressSteps } from '@/widgets/ActivateProgressSteps';
import { getActiveCertification } from 'src/utils/escrow';

import { useEscrowDashboardCard } from '../model/context';

const progressSteps = [
  { value: 'setup' as const, label: 'Setup' },
  { value: 'review' as const, label: 'Review' },
  { value: 'signature' as const, label: 'Signature' },
  { value: 'activation' as const, label: 'Activation' },
];

const statusToActiveStepMap = {
  [EscrowStatusEnum.Onboarding]: 'review',
  [EscrowStatusEnum.Signed]: 'activation',
  [OtherEscrowStatusEnum.ActivationProcess]: 'activation',
  [EscrowStatusEnum.Terminated]: 'activation',
  [EscrowStatusEnum.AdminReview]: 'setup',
  [OtherEscrowStatusEnum.AwaitingSignature]: 'signature',
} as const;

const Progress = () => {
  const { viewModel } = useEscrowDashboardCard();
  const { status, previousStatus, activatedAt, certificationVerified, certificationCertified } = viewModel;

  const activeCertification = getActiveCertification({
    activatedAt,
    certificationVerified,
    certificationCertified,
  });

  if (activeCertification) return null;

  const activeStep = statusToActiveStepMap[(previousStatus ?? status) as keyof typeof statusToActiveStepMap] ?? 'setup';

  return <BasicActivateProgressSteps steps={progressSteps} activeStep={activeStep} className="w-[135px]" />;
};

export { Progress };
